import {
	type Conversation,
	isStoreAssistant,
	type StoreAssistant,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const getSourceAgentId = (
	messages: StoreChatItem[],
	conversation?: Conversation,
): string | undefined => {
	const assistantMessage = messages.find((message) => isStoreAssistant(message)) as
		| StoreAssistant
		| undefined;

	// the final fallback correctly selects an agent if a user cancels a session
	return (
		conversation?.sourceAgentId ??
		assistantMessage?.content.message.message.author_id ??
		conversation?.agent?.agent_id
	);
};
